





















import { Component, Prop, Vue } from "@/shared/node_modules/vue-property-decorator";
import CzTag from "@/shared/components/cz/CzTag.vue";
import CzPlanRow from "@/shared/components/cz/CzPlanRow.vue";

// The course syllabus as the guideline sessions: modules with their lessons in order, done, current or locked.
@Component({ components: { CzTag, CzPlanRow } })
export default class CourseLessons extends Vue {
  @Prop({ type: Array, required: true }) sections!: any[];
  @Prop({ type: Array, default: () => [] }) progress!: any[];
  @Prop({ type: Boolean, default: false }) sequential!: boolean;
  @Prop({ type: Boolean, default: true }) enabled!: boolean;
  @Prop({ type: Number, default: 0 }) currentId!: number;
  @Prop({ type: String, default: "" }) currentLabel!: string;

  get lessons(): any[] {
    return this.sections.flatMap((s: any) => s.lessons);
  }

  isDone(lesson: any): boolean {
    const p = this.progress.find((x: any) => x.courseLessonId === lesson.id);
    return !!p && p.status === 2;
  }

  isLocked(lesson: any): boolean {
    if (!this.sequential) return false;
    const idx = this.lessons.findIndex((l: any) => l.id === lesson.id);
    return idx > 0 && !this.isDone(this.lessons[idx - 1]);
  }

  sub(lesson: any): string {
    if (this.enabled && this.isLocked(lesson)) return this.$t("Locked").toString();
    return lesson.id === this.currentId ? this.currentLabel : "";
  }

  time(s: number): string {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return m + ":" + (sec < 10 ? "0" : "") + sec;
  }
}
